import React, { useState, useEffect } from "react";

import Design from "./Design";
import {
  fetchTargets,
  RoleEvent,
  fetchWeeklyRating,
} from "../../services/benefitApi";
const Benefit = () => {
  const [weeklyData1, setWeeklyData1] = useState(null);
  const [weeklyData2, setWeeklyData2] = useState(null);
  const [weeklyRating, setWeeklyRating] = useState(null);

  const [flag, setFlag] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        const data4 = await fetchWeeklyRating();

        const data1 = await RoleEvent();
        setWeeklyData1(data1.data);
        const data2 = await fetchTargets();
        setWeeklyData2(data2.data);

        setWeeklyRating(data4.data);
      } catch (err) {
        setError(err.message);
      } finally {
      }
    };

    fetchData();
  }, [flag]);
  return (
    <div>
      <Design
        weeklyData1={weeklyData1}
        weeklyData2={weeklyData2}
        flag={flag}
        setFlag={setFlag}
        weeklyRating={weeklyRating}
      />
    </div>
  );
};

export default Benefit;
